var ReactTooltip = require("react-tooltip");

import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");

var DataRouting = require("lib/routing/DataRouting");

var WritingActions = require("lib/actions/WritingActions");
var ReadingActions = require("lib/actions/ReadingActions");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WidgetConfig = require('lib/widgets/WidgetsConfig')

var QuizDisplay = require("components/writing/quizzes/QuizDisplay");
var AnswerDisplay = require("components/writing/answers/AnswerDisplay");
var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var DataTable = require("components/data/subjects/shared/DataTable");
var EmptyState = require("components/data/EmptyState");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var Glyphicon = require("components/utility/icons/Glyphicon");

import moment from 'moment';

function propsToConditions(props) {
  var conditions = _.pick(props,
    "startDate", "endDate", "textVariety", "textID", "userIDs", "order", "status"
  );

  conditions.perPage = props.perPage || DataRouting.PER_PAGE;
  conditions.withTotal = true;

  if (conditions.startDate && conditions.endDate) {
    // reverse the time zone offset pull all quizzes based
    // on the user's time zone
    var currentUser = CurrentUser.get()
    if (currentUser.time_zone_offset) {
      var offset = -currentUser.time_zone_offset / (60 * 60);
    } else {
      var offset = 7 // default to Pacific time
    }

    conditions.startDate = moment(conditions.startDate).startOf('day').utcOffset(offset).format("YYYY-MM-DD")
    conditions.endDate = moment(conditions.endDate).endOf('day').utcOffset(offset).format("YYYY-MM-DD")
  }

  return conditions;
}

function sortItems(quizzes) {
  return _.sortBy(quizzes, (x) => (new Date(x.completed_at)).valueOf()).reverse();
}

// FOR DEMO PURPOSES ONLY
// REMOVE THIS JUNK IMMEDIATELY ONCE L2E CAN TELL
// WEB IF A QUIZ IS PASSED
function filterStatus(quizzes, state, props) {
  if (!props.status) { return quizzes }

  var prefs = RosterSelectors.globalStudentListPrefs({ state });
  return _.filter(quizzes, quiz => {
    var evaluation = WritingSelectors.evaluation({ state, id: quiz.evaluation })
    if (!evaluation) { return false }

    if (props.status == 'flagged') { 
      return evaluation.filtered
    } else if (props.status == 'failed') {
      return !WidgetConfig.isPassing(evaluation, prefs.passing_threshold)
    } else if (props.status == 'passed') {
      return WidgetConfig.isPassing(evaluation, prefs.passing_threshold)
    }
  })

}

@connect(
  (state, props) => ({
    loading: WritingSelectors.isLoadingQuizzes({ state, key: 'index', userIDs: props.userIDs }),
    quizzes: filterStatus(sortItems(WritingSelectors.quizzes({ state, conditions: propsToConditions(props) })), state, props),
    books: ReadingSelectors.books({state, conditions: propsToConditions(props)})
  }),
  (dispatch, props) => ({
    populateData: () => {
      var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order", "status")
      var actionFunction = WritingActions.fetchQuizzes      
      var embeds = ["quiz.evaluation", "quiz.answer_ids", "evaluation.score_details"]      

      var options = { embeds, cache: true }
      return new Promise(function (resolve, reject) {
        $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null);

      }).catch(() => console.log("Quizzes failed to load"))
    },
    fetchBooks: (textIDs) => {
      return dispatch(ReadingActions.fetchBooks({ ids: textIDs }))
    },
    fetchSingleBookActivity: (textID, userID) => {
      var embeds = ["book.answers", "answer.evaluation"]
      var conditions = { allowDraft: false };
      var query = { user_id: userID };
      return dispatch(ReadingActions.fetchSingleBookActivity(
        { id: textID, embeds, query, conditions }
      ))
    },
    selectEvaluation: (evaluationID) => {
      return dispatch((dispatch, getState) => {
        return WritingSelectors.evaluation({ state: getState(), id: evaluationID })
      })
    },
    selectStudent: (studentID) => {
      return dispatch((dispatch, getState) => {
        return RosterSelectors.student({ state: getState(), id: studentID })
      })
    },
    selectBook: (textID) => {
      return dispatch((dispatch, getState) => {
        return ReadingSelectors.book({ state: getState(), id: textID })
      })
    }
  })
)
@providePopulateData()
class DataQuizTables extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = {
      quizChunks: _.chunk(props.quizzes, DataRouting.PER_PAGE),
      currentQuizPage: 1,
      totalCount: _.size(props.quizzes),
      showAdditionalAnswers: false,
      currentAnswerPage: 1
    }

    LuckyOrangeClient.tagComponent("DataQuizTables");
  }

  singleQuiz() {
    if (!this.props.quizID) { return null }    
    return _.findWhere(this.props.quizzes, { id: this.props.quizID })
  }

  additionalAnswerIDs() {
    if (!this.singleQuiz()) { return null }
    
    var book = this.props.selectBook(this.singleQuiz().text_id)
    return book && book.answers ? book.answers : []
  }

  toggleShowAdditionalAnswers() {
    this.setState({ showAdditionalAnswers: !this.state.showAdditionalAnswers })
  }
  
  onQuizPageChange(page) {
    this.setState({ currentQuizPage: page });
  }

  onAnswerPageChange(page) {
    this.setState({ currentAnswerPage: page });
  }

  changeLocationState(quizID, controlMode) {    
    if (!_.isEmpty(this.props.prevLocationState)) {
      var newLocationState = { ...this.props.prevLocationState }
    } else if (quizID && quizID != null) {
      var newLocationState = { ...this.props.locationState }
      newLocationState.quizID = quizID
    } else {
      var newLocationState = _.omit({ ...this.props.locationState }, 'quizID')
    }

    this.props.updateRoute(newLocationState)
  }

  formatDate(date) {
    return $wr.formatDate(date, "MM/DD/YY")
  }

  // link to view quiz answers
  buildViewLink(quizID) {
    return (
      <span className="itemLink">
        <a className='hideOnPrint' onClick={() => this.changeLocationState(quizID)}>
          <Glyphicon icon="new-window" />
        </a>
      </span>
    )
  }

  // hides score for free user until they manually enter it
  hideAutograderScore(evaluation) {
    return !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score
  }

  // link that sends user to quiz view with edit tab open
  renderGradeQuizLink(quiz) {
    return (
      <a onClick={() => this.changeLocationState(quiz.id, EDIT_CONTROLS)} className='gradeQuizLink'>
        {`Grade Quiz`}
      </a>
    )
  }

  generateQuizRows(quizzes) {
    return _.map(quizzes, quiz => {
      var { completed_at, user_id, text_id, evaluation } = quiz

      // evaluation for quiz
      var evaluation = this.props.selectEvaluation(evaluation)
      // student information
      var student = this.props.selectStudent(user_id)
      // book information
      var book = this.props.selectBook(text_id)

      var title = book ? book.title : ''

      var rubricValue = _.pick(_.pick(evaluation, "restated", "text_evidence", "fully_answered"), _.identity)
      
      var readBookValue = ''
      var readBookConfidence = ''
      if (evaluation && this.hideAutograderScore(evaluation)) { 
        var evalValue = this.renderGradeQuizLink(quiz)
      } else if (evaluation) {
        var evalValue = <ScoreDisplay evaluationID={evaluation.id} changeLocationState={this.changeLocationState} mode={ScoreDisplay.SCORE_ONLY_MODE} />
        var readBookValue = evaluation.read_book
        var readBookConfidence = evaluation.read_book_confidence
      } else {
        var tooltipText = "Pending. This quiz will be graded within 24 hours.";
        var evalValue = (
          <span data-tip={tooltipText} data-for="hourglassDataTip">
            <Glyphicon icon="hourglass" />
            <ReactTooltip id={`hourglassDataTip`} />
          </span>
        )
      }

      return [
        {
          // date column
          value: this.formatDate(completed_at),
          classes: ['no-wrap', 'dateColumn']
        },
        {
          // student name column
          value: student.display_name,
          classes: ['studentNameColumn'],
        },
        {
          // book title column
          value: title,
          classes: ['pre-wrap', 'italic', 'bookTitle']
        },
        {
          // displays quiz evaluation score
          value: evalValue,
          classes: ['bold', 'quizScoreColumn']
        },
        {
          // displays determination on wether the student
          // read the book or not
          value: readBookValue,
          classes: ['no-wrap', 'readBookColumn'],
          read_book_column: true,
          confidence: 95,

        },
        {
          // displays rubric performance
          value: rubricValue,
          classes: ['no-wrap', 'rubricColumn'],
          rubric_column: true,
          confidence: readBookConfidence,

        },
        {
          // view quiz answers
          value: this.buildViewLink(quiz.id),
          classes: ['no-wrap', 'viewColumn'],
        },
      ]
    })
  }

  loadPagination() {
    if (this.state.totalCount && !this.props.quizID) {
      return (
        <PaginationControls page={this.state.currentQuizPage}
          perPage={DataRouting.PER_PAGE}
          totalCount={this.state.totalCount}
          onPageChange={this.onQuizPageChange} />
      )
    }
  }

  // chunks and returns answer displays and total count
  renderAnswerDisplays() {
    var enabled = { ...this.props.enabled };
    var view = AnswerDisplay.ANSWERS_VIEW;
    var answers = _.map(this.additionalAnswerIDs(), (aid, i) => {
      if (i != _.size(this.additionalAnswerIDs()) - 1) {
        var divider = <hr />
      }

      return (
        <span>
          <AnswerDisplay answerID={aid} key={aid}
            enabled={enabled} view={view} />
          {divider}
        </span>
      )
    })

    return { 'totalCount': _.size(answers), 'answers': _.chunk(answers, DataRouting.PER_PAGE)[this.state.currentAnswerPage - 1] }
  }

  renderPracticeQuestions() {
    if (!_.isEmpty(this.additionalAnswerIDs())) {
      var { totalCount, answers } = this.renderAnswerDisplays()
      var expandedClass = 'collapsed'
      var header = `${_.size(this.additionalAnswerIDs())} Practice ${$wr.pluralize('Question', _.size(this.additionalAnswerIDs()), 'Questions')} For This Text`
      var icon = 'menu-down'

      if (this.state.showAdditionalAnswers) {
        expandedClass = 'expanded'
        header = `Hide Practice ${$wr.pluralize('Question', _.size(this.additionalAnswerIDs()), 'Questions')}`
        icon = 'menu-up'
      }

      return (
        <div className={`additonalAnswersContainer ${expandedClass}`}>
          <div className="headerSection" onClick={this.toggleShowAdditionalAnswers}>
            {header}
            <div className="menuOption"><Glyphicon icon={icon}/></div>
          </div>
          <div className="answersContainer">
            <PaginationControls page={this.state.currentAnswerPage}
              perPage={DataRouting.PER_PAGE}
              totalCount={totalCount}
              onPageChange={this.onAnswerPageChange} />
            {answers}
          </div>
        </div>
      )
    }
  }

  renderSingleQuizDisplay() {
    return (
      <div className="singleQuizView">
        <QuizDisplay quizID={this.props.quizID} controlMode='Analysis' view="quizzes" enabled={{ ...this.props.enabled }} />
        {this.renderPracticeQuestions()}
      </div>
    )
  }

  renderQuizDisplay() {
    if (this.props.loading) {
      return <Spinner />
    } 

    var quizzes = this.props.showFullData ? this.state.quizChunks[this.state.currentQuizPage - 1] : _.first(this.props.quizzes, 1);
    if (quizzes) {
      if (this.props.fakePerPage) {
        quizzes = _.first(quizzes, this.props.fakePerPage)
      }
      // if quizID param, show single quiz with all answers
      // else, show table of quizzes
      if (this.props.quizID) {
        return this.renderSingleQuizDisplay()
      } else {
        return (
          <DataTable
            subjectType={QUIZZES}
            columnHeaders={QUIZ_TABLE_HEADERS}
            rows={this.generateQuizRows(quizzes)}
            printable={false}
          />
        )
      }
    } else {
      if (this.props.sketchEmptyState) {
        return <NoActivityBlock userIDs={this.props.userIDs} contentType="Quizzes" />
      } else {
        return <EmptyState type={QUIZZES} />
      }
    }
  }

  renderPrintableQuizDisplay() {
    var { quizzes, loading } = this.props
    if (!this.props.quizID && quizzes && !loading) {
      var quizzes = _.flatten(this.state.quizChunks)
      return (
        <DataTable
          subjectType={QUIZZES}
          columnHeaders={QUIZ_TABLE_HEADERS}
          rows={this.generateQuizRows(quizzes)}
          printable={true}
        />
      )
    }
  }

  render() {
    return (
      <div className="dataQuizTables">
        {this.loadPagination()}
        {this.renderQuizDisplay()}
        {this.renderPrintableQuizDisplay()}
        {this.loadPagination()}
      </div>
    )
  }

  loadBooks(prevProps) {
    // load new text ids
    var booksLoaded = prevProps == null ? [] : _.pluck(prevProps.quizzes, 'text_id')
    var allBooks = _.pluck(this.props.quizzes, 'text_id')
    var newBooks = allBooks.filter(function (obj) { return booksLoaded.indexOf(obj) == -1; });
    if (!_.isEmpty(newBooks)) {
      this.props.fetchBooks(newBooks);
    }
  }

  componentDidMount() {
    this.loadBooks(null)
    if (this.singleQuiz()) {
      this.props.fetchSingleBookActivity(this.singleQuiz().text_id, this.singleQuiz().user_id)
    }
  }

  componentDidUpdate(prevProps) {
    this.loadBooks(prevProps)
  }
}

var QUIZZES = "quizzes";
var QUIZ_TABLE_HEADERS = ['Date', 'Student', 'Title', 'Score', 'Read Book', 'Rubric', '']
var EDIT_CONTROLS = "Edit";

var RUBRIC = {
  "02_READ-COMP_fully-answered": { text: "2. Is the question fully answered?", "options": ["yes", "no"], "answer": "yes" },
  "10_READ-COMP_restating": { text: "10. Restating is present", "options": ["yes", "yes not literal", "no"], "answer": "yes" },
  "14_TEXT-SPE_text-details-count": { text: "14. Text details", "options": ["sufficient", "insufficient"], "answer": "insufficient" },
}

DataQuizTables.defaultProps = {
  enabled: {}
}

DataQuizTables.WrappedComponent.propTypes = PageStrictPropTypes({
  // Data from above
  userIDs: PropTypes.array,
  startDate: PropTypes.string,
  page: PropTypes.number,
  perPage: PropTypes.number,
  fakePerPage: PropTypes.number,
  order: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  status: PropTypes.string,
  textVariety: PropTypes.string,
  textID: PropTypes.string,
  showFullData: PropTypes.bool,
  sketchEmptyState: PropTypes.bool,
  studentList: PropTypes.string,
  quizID: PropTypes.number,
  locationState: PropTypes.object,
  prevLocationState: PropTypes.object,
  updateRoute: PropTypes.func,
  onPageChange: PropTypes.func,
  fetchSingleBookActivity: PropTypes.func,

  // Reference QuizDisplay 'enabled'
  enabled: PropTypes.object,

  // Data from @connect
  loading: PropTypes.bool,
  quizzes: PropTypes.array,
  books: PropTypes.array,

  // Handlers from @connect
  populateData: PropTypes.func,
  fetchBooks: PropTypes.func,
  selectEvaluation: PropTypes.func,
  selectStudent: PropTypes.func,
  selectBook: PropTypes.func
})

module.exports = DataQuizTables;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataQuizTables.js